module.exports = __webpack_public_path__ + "img/people-surfing-illustration.272f5f3e.png";